// en, de, fr, pt
export default {
	en: {
		Settings: 'Settings',
		Dashboard: 'Dashboard',
		DataAndAnalytics: 'Data & Analytics',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
		WhatsApp: 'WhatsApp',
		Sms: 'Sms',
		Rules: 'Regras',
		ContractProposalPdf: 'Termos de Uso',
		DynamicSettings: 'Ajustes',
		ConversationBot: 'Bot de Conversa',
		PassiveChatFlow: 'Fluxo Passivo',
		ActiveChatFlow: 'Fluxo Ativo',
		ChatAttendance: 'Chat',
		UserDepartment: 'Departamentos',
		BackOffice: 'BackOffice',
		WaboxConnections: 'Wabox Connections',
		Instances: 'Instances',
		NumbersBlacklist: 'Contatos Bloqueados',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuexy: 'Vuexy',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
		CardColors: 'Card Colors',
		Table: 'Table',
		agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
		ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
		FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Help: 'Help',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
		Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		User: 'User',
		View: 'View',
		Edit: 'Edit',
		UserSettings: 'User Settings',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		I18n: 'I18n',
		Clipboard: 'Clipboard',
		StarRatings: 'Star Ratings',
		// "Import/Export": 'Import/Export',
		Import: 'Import',
		Export: 'Export',
		ExportSelected: "Export Selected",
		Others: 'Others',
		Support: 'Support',
		UserManual: 'User Manual',
		WhatsAppProtocol: 'Protocolo do WhatsApp',
		Access: 'Acessos',
		Roles: 'Permissões',
		TrainingVideos: 'Vídeos de Treinamento',
		Customers: 'Customers',
		CustomerGroups: 'CustomerGroups',
		CustomersBase: 'Customers Base',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
	},
	pt: {
		Settings: 'Configurações',
		Dashboard: 'painel de controle',
		Report: 'Report',
		DataAndAnalytics: 'Dados e Métricas',
		eCommerce: 'comércio eletrônico',
		TargetAudience: 'Público Alvo',
		Campaigns: 'Campanhas',
		Apps: 'APPS',
		Todo: 'Façam',
		Chat: 'Bate-papo',
		Email: 'O email',
		Calendar: 'Calendário',
		FullCalendar: 'Calendário Completo',
		SimpleCalendar: 'Calendário Simples',
		Shop: 'fazer compras',
		ItemDetails: 'Detalhes do item',
		Cart: 'Carrinho',
		WishList: 'Lista de Desejos',
		Checkout: 'Confira',
		UI: 'UI',
		Users: 'Usuários',
		WhatsApp: 'WhatsApp',
		Sms: 'Sms',
		Rules: 'Regras',
		ContractProposalPdf: 'Termos de Uso',
		DynamicSettings: 'Ajustes',
		ConversationBot: 'Bot de Conversa',
		PassiveChatFlow: 'Fluxo Passivo',
		ActiveChatFlow: 'Fluxo Ativo',
		ChatAttendance: 'Chat',
		UserDepartment: 'Departamentos',
		BackOffice: 'BackOffice',
		WaboxConnections: 'Conexões Wabox',
		Instances: 'Conexões',
		NumbersBlacklist: 'Contatos Bloqueados',
		DataList: 'Lista de dados',
		ListView: 'Exibição de lista',
		ThumbView: 'Thumb View',
		Grid: 'Grade',
		Vuexy: 'Vuexy',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Cores',
		Card: 'Cartão',
		Basic: 'Basic',
		Statistics: 'Estatisticas',
		Analytics: 'Analytics',
		CardActions: 'Ações do Cartão',
		CardColors: 'Cores do cartão',
		Table: 'Mesa',
		agGridTable: 'Tabela AgGrid',
		Components: 'Componentes',
		Alert: 'Alerta',
		Avatar: 'Avatar',
		Badge: 'Crachá',
		Breadcrumb: 'Breadcrumb',
		Button: 'Botão',
		ButtonGroup: 'Grupo de botões',
		Chip: 'Lasca',
		Collapse: 'Colapso',
		Dialogs: 'Diálogos',
		Divider: 'Divisor',
		DropDown: 'Suspenso',
		List: 'Lista',
		Loading: 'Carregando',
		Navbar: 'Navbar',
		Notifications: 'Notificações',
		Pagination: 'Paginação',
		Popup: 'Aparecer',
		Progress: 'Progresso',
		Sidebar: 'Barra Lateral',
		Slider: 'Controle Deslizante',
		Tabs: 'Guias',
		Tooltip: 'dica de ferramenta',
		Upload: 'Envio',
		FormsAndTable: 'Formulários e tabela',
		FormElements: 'Elementos do formulário',
		Select: 'Selecione',
		Switch: 'Interruptor',
		Checkbox: 'Caixa de seleção',
		Radio: 'Rádio',
		Input: 'Entrada',
		NumberInput: 'Entrada numérica',
		Textarea: 'Textarea',
		FormLayouts: 'Layouts de formulário',
		FormWizard: 'Assistente de Formulário',
		FormValidation: 'Validação de Formulário',
		FormInputGroup: 'Grupo de entrada de formulário',
		Pages: 'PÁGINAS',
		Authentication: 'Autenticação',
		Login: 'Entrar',
		Register: 'Registo',
		ForgotPassword: 'Esqueceu A Senha',
		ResetPassword: 'Redefinir Senha',
		LockScreen: 'Tela de bloqueio',
		Miscellaneous: 'Diversos',
		ComingSoon: 'Em breve',
		Error: 'Erro',
		404: '404',
		500: '500',
		NotAuthorized: 'Não autorizado',
		Maintenance: 'Manutenção',
		Profile: 'Perfil',
		User: 'Do utilizador',
		View: 'Visão',
		Edit: 'Editar',
		UserSettings: 'Configurações do Usuário',
		Invoice: 'Fatura',
		FAQ: 'Perguntas frequentes',
		Search: 'Procurar',
		KnowledgeBase: 'Base de Conhecimento',
		ChartsAndMaps: 'Gráficos E Mapas',
		Charts: 'Gráficos',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Mapa',
		Extensions: 'Extensão',
		QuillEditor: 'Quill-Editor',
		DragAndDrop: 'Arraste e solte',
		Datepicker: 'Datepicker',
		DatetimePicker: 'Seletor de data e hora',
		AccessControl: 'Controle de acesso',
		I18n: 'I18n',
		Carousel: 'Carrossel',
		Clipboard: 'Prancheta',
		ContextMenu: 'Menu contextual',
		StarRatings: 'Classificações por estrelas',
		Autocomplete: 'autocompletar',
		Tree: 'Árvore',
		// "Import/Export": 'Importar/Exportar',
		Import: 'Importar',
		Export: 'Exportar',
		ExportSelected: "Exportar Selecionado",
		Others: 'Outras',
		MenuLevels: 'Níveis de Menu',
		MenuLevel2p1: 'Nível de menu 2.1',
		MenuLevel2p2: 'Nível de menu 2.2',
		MenuLevel3p1: 'Nível de menu 3.1',
		MenuLevel3p2: 'Nível de menu 3.2',
		DisabledMenu: 'Menu desativado',
		Support: 'Suporte',
		Help: 'Regras e Ajuda',
		UserManual: 'Manual de Uso',
		WhatsAppProtocol: 'Protocolo do WhatsApp',
		Access: 'Acessos',
		Roles: 'Permissões',
		TrainingVideos: 'Vídeos de Treinamento',
		Customers: 'Lista de Contatos',
		CustomerGroups: 'Grupos de Contatos',
		CustomersBase: 'Base de Contatos',
		Documentation: 'Documentação',
		RaiseSupport: 'Levantar Suporte',
		demoTitle: 'Título do cartão',
		demoText: `O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.`,
	},
	pt_BR: {
		Settings: 'Configurações',
		Dashboard: 'Painel de Controle',
		Report: 'Produtividade',
		DataAndAnalytics: 'Dados e Métricas',
		eCommerce: 'Comércio Eletrônico',
		TargetAudience: 'Público Alvo',
		Apps: 'APPS',
		Todo: 'Afazeres',
		Chat: 'Bate-papo',
		Email: 'Email',
		Calendar: 'Calendário',
		FullCalendar: 'Calendário Completo',
		SimpleCalendar: 'Calendário Simples',
		Shop: 'Fazer Compras',
		ItemDetails: 'Detalhes do item',
		Cart: 'Carrinho',
		WishList: 'Lista de Desejos',
		Checkout: 'Confira',
		UI: 'UI',
		Users: 'Usuários',
		WhatsApp: 'WhatsApp',
		Sms: 'Sms',
		Rules: 'Regras',
		ContractProposalPdf: 'Termos de Uso',
		DynamicSettings: 'Ajustes',
		ConversationBot: 'Bot de Conversa',
		PassiveChatFlow: 'Fluxo Passivo',
		ActiveChatFlow: 'Fluxo Ativo',
		ChatAttendance: 'Chat',
		UserDepartment: 'Departamentos',
		Campaigns: 'Campanhas',
		BackOffice: 'BackOffice',
		WaboxConnections: 'Conexões Wabox',
		Instances: 'Conexões',
		NumbersBlacklist: 'Contatos Bloqueados',
		DataList: 'Lista de Dados',
		ListView: 'Exibição de Lista',
		ThumbView: 'Thumb View',
		Grid: 'Grade',
		Vuexy: 'Vuexy',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Cores',
		Card: 'Cartão',
		Basic: 'Basic',
		Statistics: 'Estatísticas',
		Analytics: 'Analytics',
		CardActions: 'Ações do Cartão',
		CardColors: 'Cores do Cartão',
		Table: 'Mesa',
		agGridTable: 'Tabela AgGrid',
		Components: 'Componentes',
		Alert: 'Alerta',
		Avatar: 'Avatar',
		Badge: 'Crachá',
		Breadcrumb: 'Breadcrumb',
		Button: 'Botão',
		ButtonGroup: 'Grupo de Botões',
		Chip: 'Chip',
		Collapse: 'Colapso',
		Dialogs: 'Diálogos',
		Divider: 'Divisor',
		DropDown: 'Suspenso',
		List: 'Lista',
		Loading: 'Carregando',
		Navbar: 'Navbar',
		Notifications: 'Notificações',
		Pagination: 'Paginação',
		Popup: 'Aparecer',
		Progress: 'Progresso',
		Sidebar: 'Barra Lateral',
		Slider: 'Controle Deslizante',
		Tabs: 'Guias',
		Tooltip: 'Dica de Ferramenta',
		Upload: 'Envio',
		FormsAndTable: 'Formulários e Tabela',
		FormElements: 'Elementos do Formulário',
		Select: 'Selecione',
		Switch: 'Interruptor',
		Checkbox: 'Caixa de Seleção',
		Radio: 'Rádio',
		Input: 'Entrada',
		NumberInput: 'Entrada Numérica',
		Textarea: 'Textarea',
		FormLayouts: 'Layouts de Formulário',
		FormWizard: 'Assistente de Formulário',
		FormValidation: 'Validação de Formulário',
		FormInputGroup: 'Grupo de Entrada de Formulário',
		Pages: 'PÁGINAS',
		Authentication: 'Autenticação',
		Login: 'Entrar',
		Register: 'Registo',
		ForgotPassword: 'Esqueceu a Senha',
		ResetPassword: 'Redefinir Senha',
		LockScreen: 'Tela de Bloqueio',
		Miscellaneous: 'Diversos',
		ComingSoon: 'Em Breve',
		Error: 'Erro',
		404: '404',
		500: '500',
		NotAuthorized: 'Não Autorizado',
		Maintenance: 'Manutenção',
		Profile: 'Perfil',
		User: 'Usuário',
		View: 'Visão',
		Edit: 'Editar',
		UserSettings: 'Configurações do Usuário',
		Invoice: 'Fatura',
		FAQ: 'Perguntas Frequentes',
		Search: 'Procurar',
		KnowledgeBase: 'Base de Conhecimento',
		ChartsAndMaps: 'Gráficos e Mapas',
		Charts: 'Gráficos',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Maps',
		Extensions: 'Extensão',
		QuillEditor: 'Quill-Editor',
		DragAndDrop: 'Arrasta e Solta',
		Datepicker: 'Datepicker',
		DatetimePicker: 'Seletor de Data e Hora',
		AccessControl: 'Controle de Acesso',
		I18n: 'I18n',
		Carousel: 'Carrossel',
		Clipboard: 'Prancheta',
		ContextMenu: 'Menu Contextual',
		StarRatings: 'Classificações por Estrelas',
		Autocomplete: 'Autocompleta',
		Tree: 'Árvore',
		// "Import/Export": 'Importar/Exportar',
		Import: 'Importar',
		Export: 'Exportar',
		ExportSelected: "Exportar Selecionado",
		Others: 'Outras',
		MenuLevels: 'Níveis de Menu',
		MenuLevel2p1: 'Nível de menu 2.1',
		MenuLevel2p2: 'Nível de menu 2.2',
		MenuLevel3p1: 'Nível de menu 3.1',
		MenuLevel3p2: 'Nível de menu 3.2',
		DisabledMenu: 'Menu Desativado',
		Support: 'Suporte',
		Help: 'Regras e Ajuda',
		UserManual: 'Manual de Uso',
		WhatsAppProtocol: 'Protocolo do WhatsApp',
		Access: 'Acessos',
		Roles: 'Permissões',
		TrainingVideos: 'Vídeos de Treinamento',
		Customers: 'Lista de Contatos',
		CustomerGroups: 'Grupos de Contatos',
		CustomersBase: 'Base de Contatos',
		Documentation: 'Documentação',
		RaiseSupport: 'Levantar Suporte',
		demoTitle: 'Título do Cartão',
		demoText: `O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.`,
	}
}
